import authHeader from "../helpers/authHeader";
import history from "../helpers/history";
import userService from "./userService";
//import alertActions from "../actions/alertActions";

const register = (firstName, lastName, email, phoneNumber, barNumber) => {
  //console.log(dob, firstName, lastName, email, password, confirmPassword);
  return fetch(
    `${process.env.REACT_APP_API_URL}/AttorneyRegistration/Register`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        firstName,
        lastName,
        email,
        phoneNumber,
        barNumber,
      }),
    }
  )
    .then(handleResponse)
    .then((data) => {
      //console.log(data);
      // store user details and jwt token in local storage to keep user logged in between page refreshes
      //sessionStorage.setItem("user", JSON.stringify(user));
      return;
    });
};

const updatePassword = async (updatePass) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(updatePass),
  };
  //console.log("login request");
  return await fetch(
    `${process.env.REACT_APP_API_URL}/ApplicationUser/UpdatePasswordAtt`,
    requestOptions
  )
    .then(handleResponse)
    .then((data) => {
      if (data.code === "PasswordUpdated") {
        userService.logout();
        history.push("/");
      }
      console.log(data);
      return;
    });
};

const updatePersonalInfo = async (personalInfo) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(personalInfo),
  };
  //console.log("login request");
  return await fetch(
    `${process.env.REACT_APP_API_URL}/ApplicationUser/UpdateUserInfoAtt`,
    requestOptions
  )
    .then(handleResponse)
    .then((userInfo) => {
      return userInfo;
    });
};

const handleResponse = (response) => {
  //console.log(response);
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      //console.log(response.message);
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        userService.logout();
      }
      const error = (data && data.message) || response.statusText;

      return Promise.reject(error);
    }

    return data;
  });
};

const attorneyService = {
  register,
  updatePersonalInfo,
  updatePassword,
};

export default attorneyService;
